'use strict';

/* jshint -W098 */
angular.module('mean.databases').controller('DatabasesMaterialListController', ['$scope', 'Global', 'MeanUser', 'userService', 'builderService', 'ngDialog', 'toaster', '$filter', 'ProjectMaterials', 'aceUtils',
  function($scope, Global, MeanUser, userService, builderService, ngDialog, toaster, $filter, ProjectMaterials, aceUtils) {
    $scope.global = Global;
    $scope.package = {
      name: 'contacts'
    };

    $scope.user = MeanUser.user;

    $scope.materials = [];
    $scope.material_names = [];

    $scope.sortType = ['supplier', 'builder_name', 'project_name', 'phase', 'lot', 'task_code'];
    $scope.sortReverse = false;

    $scope.$on('materialListLoadEvent', function (event, data) {
        $scope.materials = [];
        $scope.material_names = [];

        ProjectMaterials.query({ 'trade': $scope.user.trade[0],
            'company_code': $scope.user.contractor_code,
            'supplier': data.searchProp.supplier,
            'project_id': data.searchProp.project_id,
            'start': data.searchProp.start,
            'end': data.searchProp.end,
            'task': data.searchProp.task,
            'phase': data.searchProp.phase,
            'lot': data.searchProp.lot,
            'main_username': $scope.main_account.username,
            'populate': true }, function(reports) {

            for(var i=0; i<reports.length; i++) {
                var invoice = '';
                if(aceUtils.isUndefinedOrNull(reports[i].project_id)) {
                    toaster.pop('warning', 'Reports', 'Some project information missing');
                } else {
                    invoice = reports[i].project_id.trade_code +
                        '-' + reports[i].project_id.company_code +
                        '-' + reports[i].project_id.job_code +
                        '-' + reports[i].phase +
                        '-' + reports[i].task_code;
                }

                for(var j in reports[i].materials) {
                    var item = reports[i].materials[j];
                    var tax = (item.bid_quantity * item.price_per_order) *
                            reports[i].project_id.trades[0].company_factors.sales_tax;

                    var inlist = $filter('filter')($scope.material_names, {
                        'name': item.name}, true);

                    if(inlist.length === 0) {
                        $scope.material_names.push({
                            'name': item.name
                        });
                    }

                    $scope.materials.push({
                        _id: item._id,
                        supplier: reports[i].supplier,
                        builder_name: reports[i].project_id.builder.name,
                        job_code: reports[i].project_id.job_code,
                        project_name: reports[i].project_id.name,
                        phase: reports[i].phase,
                        lot: item.lot,
                        task_code: reports[i].task_code,
                        invoice_number: invoice,
                        name: item.name,
                        bid_note: item.bid_note,
                        foreman_note: item.foreman_note,
                        bid_quantity: item.bid_quantity,
                        quantity: item.quantity,
                        date_ordered: reports[i].date_ordered,
                        date_submitted: reports[i].date_submitted,
                        bid_total: item.bid_quantity * item.price_per_order + tax,
                        actual_total: item.total
                    })
                }
            }

            $scope.$emit('materialNamesLoadEvent', {
                names: $scope.material_names
            });
        });
    });
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/databases/public/controllers/databases-material-list.js